import DesignTokens from '@tableau/design-tokens';
import { NotificationCheckIconRaw } from '@tableau/icons/NotificationCheckIcon/raw';
import { ReactiveRawIconRegistry } from '@tableau/icons/reactive';
import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

const cssPrefix = 'preview';
export const imageContent = cssClass(cssPrefix, 'imageContent', {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 600,
});

export const dqwImageContent = cssClass(cssPrefix, 'dqwImageContent', {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 500,
});

export const labelManagementImageContent = cssClass(cssPrefix, 'labelManagementImageContent', {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 800,
  minHeight: 450,
  border: '1px solid',
  borderColor: applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.Grey245)
});

export const getListWrapper = () => cssClass(cssPrefix, 'listWrapper', {
  listStyleImage: `var(${ReactiveRawIconRegistry.register(NotificationCheckIconRaw, 12, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})`,
  paddingInlineStart: 20,
  $nest: {
    'li': {
      padding: '8px 4px',
    }
  }
});

export const header = cssClass(cssPrefix, 'header', {
  fontSize: TabStyles.Typography.Sizing.XLarge,
  paddingBottom: 12,
});

export const labelManagementHeader = cssClass(cssPrefix, 'labelManagement-header', {
  fontSize: TabStyles.Typography.Sizing.XLarge,
  paddingBottom: TabStyles.Spacing.ExtraLargeSpace,
});

export const labelManagementBody = cssClass(cssPrefix, 'labelManagement-body', {
  paddingBottom: TabStyles.Spacing.LargeSpace,
});

export const labelManagementButtonWrapper = cssClass(cssPrefix, 'labelManagement-buttonWrapper', {
  display: 'flex',
  gap: 36,
  paddingTop: TabStyles.Spacing.LargeSpace,
});

export const buttonWrapper = cssClass(cssPrefix, 'buttonWrapper', {
  display: 'flex',
  gap: 8
});

export const textContent = cssClass(cssPrefix, 'textContent', {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 380,
});

export const dqwTextContent = cssClass(cssPrefix, 'dqw-textContent', {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 400,
});

export const labelManagementTextContent = cssClass(cssPrefix, 'labelManagement-textContent', {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 450,
  maxWidth: 600,
});

export const wrapper = cssClass(cssPrefix, 'wrapper', {
  display: 'flex',
  padding: 40,
  gap: 40,
});

export const dqwWrapper = cssClass(cssPrefix, 'dqw-wrapper', {
  display: 'flex',
  padding: 10,
  gap: 40,
});

export const labelManagementWrapper = cssClass(cssPrefix, 'labelManagement-wrapper', {
  display: 'flex',
  padding: 38,
  gap: 32,
});

export const dqwImage = cssClass(cssPrefix, 'dqw-preview-image', {
  boxShadow: '0px 0px 10px '+ applyColor(DesignTokens.color.feedback.default.neutral_light, '#d1cfcf'),
  width: 500
});
